import React from "react";
import Iframe from "react-iframe";

const VideoIframe = ({ videourl, heigh, wid }) => (
  <Iframe
    url={videourl}
    id="myId"
    height={`${heigh}%`}
    width={`${wid}%`}
    className="myClassname"
    display="initial"
    position="relative"
  />
);

export default VideoIframe;